document.addEventListener("DOMContentLoaded", function () {
  const moneyCount = 15;

  const imageUrl = "https://cdn.shopify.com/s/files/1/0956/9524/1496/files/moneyfall.png?v=1767750536";

  if (!imageUrl) return;

  for (let i = 0; i < moneyCount; i++) {
    const bill = document.createElement("img");
    bill.src = imageUrl;

    bill.style.position = "fixed";
    bill.style.top = "-120px";
    bill.style.left = Math.random() * 100 + "vw";
    bill.style.width = "120px";
    bill.style.opacity = "0.85";
    bill.style.pointerEvents = "none";
    bill.style.zIndex = "9999";

    const duration = Math.random() * 4 + 4;
    bill.style.animation = `moneyFall ${duration}s linear infinite`;

    document.body.appendChild(bill);
  }

  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes moneyFall {
      from {
        transform: translateY(-10vh) rotate(0deg);
        opacity: 1;
      }
      to {
        transform: translateY(120vh) rotate(360deg);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
});
